<template>
  <div class="video-player">
    <!-- ref 通过此引用去调用dhplayer内部的方法API -->
    <!-- videoId 唯一标识 -->
    <!-- windowType 0-实时预览，3-录像回放，7-录像回放(支持倒放) -->
    <!-- coverShieldClass 处理DOM元素遮挡问题，主要用于滚动页面，超出隐藏的问题 -->
    <!-- shieldClass 处理DOM元素遮挡问题 -->
    <dh-player ref="dhPlayerDemo" videoId="dhPlayerA"
      :shieldClass="['el-message', 'el-message-box', 'el-dialog', 'el-picker-panel', 'hover-blur-panel']"
      :windowType="windowType" :division="division" @createSuccess="createSuccess" @createError="createError"
      @clickWindow="clickWindow" @playbackSuccess="playbackSuccess" @playbackError="playbackError"
      @playbackFinish="playbackFinish" @switchStartTime="switchStartTime" @picCap="picCap"
      @videoDownloadSuccess="videoDownloadSuccess"></dh-player>
  </div>
</template>

<script>
import { api } from "../api.js";
import DhPlayer from "@/components/business/dh-player/index.vue"
import busVue from "@/common/utils/busVue";
export default {
  components: {
    DhPlayer
  },
  data() {
    return {
      // 播放类型
      windowType: 7,
      // 窗格数
      division: 1,
      // 当前窗口
      currentNum: 0,
      // 最大只支持64路播放
      maxWin: 64,
      recordCurrentTime: null,
      recordCurrentObj: null,
      firstIp: ''
    };
  },
  created() {
    let hostName = location.hostname;
    let ipIndex = hostName.indexOf('.')
    if (ipIndex !== -1) {
      this.firstIp = hostName.substring(0, ipIndex)
    }
    // 接收录像回放时间回调
    busVue.$on("dhHandleChooseCameraVideoBack", (info) => {
      this.recordCurrentObj = info
      this.queryPlayBackVideoRtsp(info);
    });
  },
  beforeDestroy() {
    busVue.$off("dhHandleChooseCameraVideoBack");
    this.$refs.dhPlayerDemo.closeVideo()
    this.$refs.dhPlayerDemo.destroy()
  },
  methods: {
    videoDownloadSuccess(recordUrl) {
      this.$message.success("本地录像下载完成，地址为：" + recordUrl)
    },
    // 创建成功回调
    createSuccess() {
      console.log("插件创建成功！")
    },
    // 插件创建失败回调
    createError(err) {
      console.log("插件创建失败", err)
    },
    // 点击的窗口
    clickWindow(snum, item) {
      this.currentNum = snum
      this.recordCurrentObj = item
      console.log("点击窗口信息", this.recordCurrentObj)
    },
    playbackSuccess(info) { // 返回通道信息
      console.log("录像播放成功", info)
    },
    playbackError(info, err) { // 返回通道信息和错误消息
      console.log("录像播放失败", info, err)
    },
    playbackFinish(info) { // 返回通道信息
      console.log("当前录像播放完成", info)
    },
    // 抓图回调
    picCap(item) {
      // console.log(item)
      let time = new Date().getTime()
      var img = "data:image/png;base64," + item.base64Url
      var link = document.createElement('a');
      link.href = img;
      link.download = `抓拍图片${time}.png`;
      link.click();
    },
    switchStartTime(time) {
      // if (time.startTime <= this.recordCurrentObj.startTime || time.startTime >= this.recordCurrentObj.endTime) {
      //   this.$message.error("超出录像时间范围")
      // } else {
      //   this.recordCurrentTime = time.startTime
      //   this.currentNum = time.snum
      //   this.queryPlayBackVideoRtsp(this.recordCurrentObj)
      //   // console.log(time, "当前拖拽到的时间点")
      // }
      if (time.startTime >= this.recordCurrentObj.endTime) {
        this.$message.error("超出录像时间范围")
      } else {
        this.recordCurrentTime = time.startTime
        this.currentNum = time.snum
        this.queryPlayBackVideoRtsp(this.recordCurrentObj)
        // console.log(time, "当前拖拽到的时间点")
      }
    },
    // 查询摄像机录像流
    queryPlayBackVideoRtsp(option) {
      if (this.recordCurrentTime) {
        this.recordStartTime = this.recordCurrentTime
      } else {
        this.recordStartTime = option.startTime
      }
      this.recordEndTime = option.endTime
      const param = {
        deviceId: option.channelId,
        protocol: 'rtsp',
        startTime: this.recordStartTime,
        endTime: this.recordEndTime,
      }
      this.$fetch(api.queryPlayBackVideoRtsp, param).then(res => {
        if (res.success) {
          let inNetUrl = res.returnObj.url.rtsp.substring(0, res.returnObj.url.rtsp.indexOf('|'))
          let outNetUrl = res.returnObj.url.rtsp.substr(res.returnObj.url.rtsp.indexOf('|') + 1, res.returnObj.url.rtsp.length)
          // console.log('内网', inNetUrl)
          // console.log('外网', outNetUrl)
          let rtspUrl = ''
          if (this.firstIp == '10' || this.firstIp == '172' || this.firstIp == '192') {
            rtspUrl = inNetUrl
          } else {
            rtspUrl = outNetUrl
          }
          let rtspObj = {
            channelId: option.channelId,
            path: rtspUrl,
            startTime: this.recordStartTime,
            endTime: this.recordEndTime,
          }
          this.playbackByUrl(rtspObj)
          this.recordCurrentTime = null
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    playbackByChannel(deviceInfo) {
      let param = [
        {
          channelId: deviceInfo.channelId, // 通道id
          channelName: deviceInfo.channelName, // 通道名称 (用于本地录像下载和错误提示)
          startTime: deviceInfo.startTime, // 开始时间
          endTime: deviceInfo.endTime, // 结束时间
          recordSource: 2, // 录像类型 2-设备录像 3-中心录像
          streamType: 0, // 0-所有码流 1-主码流  2-辅码流
          snum: this.currentNum //  播放的窗口序号 (从0开始计数，表示第一个窗口)
        }
      ]
      // this.$refs.dhPlayerDemo.startPlayback(param, "") // 可传download，可不传
      this.$refs.dhPlayerDemo.startPlayback(param) // 可传download，可不传
      this.currentNum = this.currentNum + 1
    },
    // 通过rtsp播放录像回放
    playbackByUrl(deviceInfo) {
      let param = {
        channelId: deviceInfo.channelId,
        records: [], // 该参数通过调用 icc 的查询录像接口获取, 直接将数组放入即可
        path: deviceInfo.path,  // rtsp 流地址
        startTime: deviceInfo.startTime, // 传入开始时间和结束时间。
        endTime: deviceInfo.endTime, // 传入结束时间。
      }
      // console.log(param, '录像参数')
      this.$refs.dhPlayerDemo.playbackByUrl(param, this.currentNum) // 当前要播放的窗口号 ()
      this.currentNum = this.currentNum + 1
    },
  }
}
</script>

<style lang="scss" scoped>
.video-player {
  width: 100%;
  height: 100%;
}
</style>